import { render, staticRenderFns } from "./OrganisationTheming.vue?vue&type=template&id=5f275836&"
import script from "./OrganisationTheming.vue?vue&type=script&lang=js&"
export * from "./OrganisationTheming.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationTheming.vue?vue&type=style&index=0&id=5f275836&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports